import { useEffect, useState } from "react";

function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
}

export default function TableOfContents({ sections = [] }) {
  const [active, setActive] = useState("");

  useEffect(() => {
    const handler = () => {
      const headings = sections.map((s) => document.getElementById(slugify(s.heading)));
      let current = "";
      for (const h of headings) {
        if (!h) continue;
        const rect = h.getBoundingClientRect();
        if (rect.top < 180) current = h.id;
      }
      setActive(current);
    };
    window.addEventListener("scroll", handler, { passive: true });
    handler();
    return () => window.removeEventListener("scroll", handler);
  }, [sections]);

  if (!sections.length) return null;

  return (
    <nav
      aria-label="Table of contents"
      className="hidden lg:block sticky top-24 self-start"
      data-testid="table-of-contents"
    >
      <p className="eyebrow mb-4">On this page</p>
      <ul className="space-y-2.5 border-l border-neutral-200">
        {sections.map((s) => {
          const id = slugify(s.heading);
          const isActive = active === id;
          return (
            <li key={id}>
              <a
                href={`#${id}`}
                className={`block pl-4 -ml-px border-l text-sm transition-colors ${
                  isActive
                    ? "border-indigo-800 text-indigo-900 font-semibold"
                    : "border-transparent text-neutral-500 hover:text-indigo-800"
                }`}
                data-testid={`toc-link-${id}`}
              >
                {s.heading}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export { slugify };
